import { map, lerp, getMousePos, calcWinsize, getRandomNumber, getElementRotate } from './utils';

// Calculate the viewport size
let winsize = calcWinsize();
window.addEventListener('resize', () => winsize = calcWinsize());

// Track the mouse position
let mousepos = {x: winsize.width/2, y: winsize.height/2};
window.addEventListener('mousemove', ev => mousepos = getMousePos(ev));

export default class GridItem {
    constructor(el) {
        this.DOM = {el: el};
        this.move();

        this.rotation = getElementRotate(el);
    }
    // Move the items when moving the cursor
    move() {
        // amounts to move in each axis
        let translationVals = {tx: 0, ty: 0};
        // get random start and end movement boundaries
        const xstart = getRandomNumber(60,120);
        const ystart = getRandomNumber(60,120);

        // infinite loop
        const render = () => {
            // Calculate the amount to move.
            // Using linear interpolation to smooth things out.
            // Translation values will be in the range of [-start, start] for a cursor movement from 0 to the window's width/height
            translationVals.tx = lerp(translationVals.tx, map(mousepos.x, 0, winsize.width, -xstart, xstart), 1);
            translationVals.ty = lerp(translationVals.ty, map(mousepos.y, 0, winsize.height, -ystart, ystart), 1);


            this.DOM.el.style.transform = `translateX(${translationVals.tx}px) translateY(${translationVals.ty}px) rotate(${this.rotation}deg)`;
            requestAnimationFrame(render);
        }

        requestAnimationFrame(render);
    }
}